"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResultsPage = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _components = require("../../components");
var _utils = require("../../components/BannerProductListing/utils");
var _useGetInitialSearchResultsData = require("../../components/BannerProductListing/utils/useGetInitialSearchResultsData");
var _useGetSearchResultsData = require("../../components/BannerProductListing/utils/useGetSearchResultsData");
var _bannerProductListingContext = require("../../contexts/bannerProductListingContext");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Used to render search results page.
 *
 * @param facets - facets for search page.
 * @param orderByOptions - order by options for search results page.
 *
 * @constructor
 */ const SearchResultsPage = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFocusPage } = (0, _bannerProductListingContext.useBannerProductListingContext)();
    const query = (0, _utils2.getSearchResultsQuery)();
    const { data, loaded, queries } = (0, _useGetInitialSearchResultsData.useGetInitialSearchResultsData)({
        query
    });
    const { getSearchResultsData } = (0, _useGetSearchResultsData.useGetSearchResultsData)({
        query
    });
    const { getFacets } = (0, _utils.useGetSearchResultsFacets)({
        query
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SEARCH_RESULTS_PAGE),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.SearchResultsHeader, {
                query: query,
                loaded: loaded,
                queries: queries
            }),
            loaded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_bannerProductListingContext.BannerProductListingProvider, {
                data: data,
                query: query,
                isFocusPage: isFocusPage,
                getFacets: getFacets,
                getData: getSearchResultsData,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.BannerProductListing, {
                    hasBottomDivider: false
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.BannerProductListingSkeleton, {
                hasBottomDivider: false
            })
        ]
    });
};
exports.SearchResultsPage = SearchResultsPage;
